module.exports = __webpack_public_path__ + "static/media/our-tests-cbd-image.13fabac7.jpg";